import { render, staticRenderFns } from "./TrashBin.vue?vue&type=template&id=4484f7cd&"
import script from "./TrashBin.vue?vue&type=script&lang=js&"
export * from "./TrashBin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports